// Fuzzy Text Animation from https://reactbits.dev/text-animations/fuzzy-text
import React, { useEffect, useState } from 'react';
import './FuzzyText.css';

const FuzzyText = ({ text, className = '' }) => {
  const [displayText, setDisplayText] = useState(text);
  const [isFuzzy, setIsFuzzy] = useState(true);

  useEffect(() => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let iteration = 0;
    
    const interval = setInterval(() => {
      setDisplayText(
        text
          .split('')
          .map((char, index) => {
            if (char === ' ') return ' ';
            if (index < iteration) {
              return text[index];
            }
            return letters[Math.floor(Math.random() * 26)];
          })
          .join('')
      );

      if (iteration >= text.length) {
        setIsFuzzy(false);
        clearInterval(interval);
      }

      iteration += 1 / 3;
    }, 30);

    return () => clearInterval(interval);
  }, [text]);

  const handleHover = () => {
    setIsFuzzy(true);
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let iteration = 0;
    
    const interval = setInterval(() => {
      setDisplayText(
        text
          .split('')
          .map((char, index) => {
            if (char === ' ') return ' ';
            if (index < iteration) {
              return text[index];
            }
            return letters[Math.floor(Math.random() * 26)];
          })
          .join('')
      );

      if (iteration >= text.length) {
        setIsFuzzy(false);
        clearInterval(interval);
      }

      iteration += 1 / 3;
    }, 30);
  };

  return (
    <span 
      className={`fuzzy-text ${className} ${isFuzzy ? 'fuzzy' : ''}`}
      onMouseEnter={handleHover}
    >
      {displayText}
    </span>
  );
};

export default FuzzyText;
